import type { Provider } from 'react';

import { createRequiredContext } from '../context';

import type { StringWrapperCtor } from './types';

interface TranslationsContextValue {
  readonly useCurrentLocale: () => string;
  readonly useHaveTranslationsCompleted: <T>(from: StringWrapperCtor<T>) => boolean;
  readonly useLoader: <T>(from: StringWrapperCtor<T>) => T;
  readonly useCurrentLocaleDirection: () => 'rtl' | 'ltr';
}

const result = createRequiredContext<TranslationsContextValue>('TranslationsContext');
const TranslationsContextProvider: Provider<TranslationsContextValue> = result[0];
const useTranslationsContext = result[1];

type UseTranslations = <T>(Strings: StringWrapperCtor<T>) => T;
export const useTranslations: UseTranslations = <T>(from: StringWrapperCtor<T>): T =>
  useTranslationsContext().useLoader(from);

export const useCurrentLocale = (): string => useTranslationsContext().useCurrentLocale();

export const useCurrentLocaleDirection = (): 'rtl' | 'ltr' => useTranslationsContext().useCurrentLocaleDirection();

export const useHaveTranslationsCompleted = <T>(Strings: StringWrapperCtor<T>): boolean =>
  useTranslationsContext().useHaveTranslationsCompleted(Strings);

export { TranslationsContextProvider };
